module.exports = __webpack_public_path__ + "media/bg.6fab370c.mp3";